import React from 'react';
import { History } from 'history';
import BaseCreate from '../base/base-create.component'; 
import BaseView from '../base/base-view.component';
import Model from './user-model';  //editable..

interface IProps { 
    history: History;
    code: string;
    save?: boolean;
    onSave?: (data: any) => void;
    onError?: (data: any) => void;
}

interface IState {
    datarow: Model;
    errors: any;
    userId: number,
    save: boolean;
}

export default class UserAuthCheckToken extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            userId: 0,
            save: false,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onError = (data: any) => {
        if (data) {
            this.setState({errors: data, save: false});
            this.props.onError?.(data)
        }
    }
    
    private onSave = async (data: any) => {
        data.token = this.props.code;
        if (data.id) {
            await this.setState({userId: data.id});
            await Model.setUser(data.id, data.name, data.imageUrl, data.token);
        }
        this.props.onSave?.(data);
        this.setState({save: false});
    }
    
    private onLoad = async(data: any) => {
        if (data.id) await Model.setUserPersonalinfo(data.personalinfo, data.personalinfoCaption);
    }

    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    public componentDidUpdate() {
        if (this.props.save && this.props.save !== this.state.save && this.props.code)
            this.setState({datarow: {...Model.defaultValueCheckToken() as any, code: this.props.code}, save: true});
    }

    render() {
        return (
            //editable..
            <>
            <BaseCreate history={this.props.history} caption=' ' buttonCaption=' ' successCaption=' '
                endPoint={Model.endPointAuth+ '/check-token'} model={Model} datarow={this.state.datarow} validations={Model.validationResetPassword} onError={this.onError} onSave={this.onSave} save={this.state.save} buttonOnBottom disableAutoBack disableBackButton disableCard />
                  
            {this.state.userId > 0 &&
            <BaseView id={this.state.userId} caption='' 
                model={Model} onLoad={this.onLoad}/>
            }
            </>
        );
    }     
     
}